var map = {
	"./africa.svg": "+cVb",
	"./analytics.svg": "Fggw",
	"./angle-brackets.svg": "svD2h",
	"./api.svg": "c2cN",
	"./app-channel-email.svg": "oPRM",
	"./app-channel-facebook.svg": "JFTI",
	"./app-channel-inapp.svg": "Je7m",
	"./app-channel-inbox.svg": "io5S",
	"./app-channel-onsite.svg": "MExm",
	"./app-channel-push.svg": "q2Nl",
	"./app-channel-sms.svg": "8WsU",
	"./app-channel-web-push.svg": "PDyC",
	"./app-channel-webhook.svg": "B0zD",
	"./app-channel-whatsapp.svg": "VDr3",
	"./app-lightning.svg": "HeF9",
	"./apple.svg": "tsZG",
	"./application.svg": "KDOV",
	"./arrow-down.svg": "tewq",
	"./arrow-enter.svg": "LWsg",
	"./arrow-right.svg": "RjqP",
	"./arrow-up.svg": "3xtq",
	"./asia.svg": "wDNT",
	"./balls-event-trig.svg": "j+gG",
	"./bank.svg": "yIOn",
	"./bell.svg": "f80l",
	"./bin-2.svg": "G3b9",
	"./bin.svg": "C8Ay",
	"./calendar.svg": "BQh+",
	"./campaign-multistage.svg": "uFOq",
	"./campaign-standard.svg": "K0c9",
	"./cancel-circle.svg": "3VgG",
	"./channel-android.svg": "rfi3",
	"./channel-apple.svg": "jsB4",
	"./channel-email.svg": "B3k2",
	"./channel-facebook.svg": "vqaW",
	"./channel-inapp.svg": "F2fA",
	"./channel-inbox.svg": "fKMB",
	"./channel-onsite.svg": "Fi6D",
	"./channel-sms.svg": "GJi+",
	"./channel-webhook.svg": "VSGH",
	"./channel-webpush.svg": "SyA5",
	"./channel-whatsapp.svg": "onUG",
	"./channel.svg": "oY56",
	"./chat.svg": "OO+m",
	"./check-circle.svg": "IXXt",
	"./check-list.svg": "CLiG",
	"./check-mark.svg": "A1v4",
	"./chevron-down.svg": "rgnG",
	"./cog.svg": "XT+n",
	"./cogs.svg": "NI4N",
	"./companies.svg": "NrwT",
	"./credit-card-disable.svg": "/RJ7",
	"./cross.svg": "BLev",
	"./crossing-arrows-horiz.svg": "RGaV",
	"./curly-brackets.svg": "cPwf",
	"./customer-intelligence.svg": "8Lc2",
	"./dashboard.svg": "Nrj4",
	"./dashboard_email.svg": "g1a4",
	"./dashboard_inapp.svg": "x4S8",
	"./dashboard_inapp_android.svg": "C6bd",
	"./dashboard_inapp_ios.svg": "Z/3y",
	"./dashboard_inbox.svg": "/XqR",
	"./dashboard_mobile_push.svg": "Ctlf",
	"./dashboard_mobile_push_android.svg": "fAQx",
	"./dashboard_mobile_push_ios.svg": "5/+5",
	"./dashboard_onsite.svg": "m/jx",
	"./dashboard_sms.svg": "YpUy",
	"./dashboard_web_push.svg": "2ZYg",
	"./datatable.svg": "ftAf",
	"./datepicker-calendar.svg": "PN8s",
	"./deep-learning.svg": "BL4M",
	"./desktop-screen.svg": "FkXf",
	"./device-data.svg": "Ebg3",
	"./devices.svg": "8v2R",
	"./discount-bubble.svg": "nTJI",
	"./documents.svg": "QOya",
	"./download.svg": "m1pJ",
	"./email-action-heart.svg": "rAsf",
	"./email-logo.svg": "GTVX",
	"./email-symbol.svg": "Uu+4",
	"./email.svg": "XGTl",
	"./europe.svg": "vc0j",
	"./event.svg": "LoQK",
	"./eye-crossed.svg": "FSMa",
	"./eye.svg": "7zll",
	"./file.svg": "eyGD",
	"./folder-opened.svg": "GXoA",
	"./funnel.svg": "q58C",
	"./gameshub-lock.svg": "UwBQ",
	"./gift-box.svg": "wleA",
	"./goal-conversion.svg": "fclW",
	"./graph-line.svg": "j8N5",
	"./hamburger-icon.svg": "DI39",
	"./handshake.svg": "6tDV",
	"./heart.svg": "smzh",
	"./home.svg": "fSTL",
	"./icon-brush.svg": "VmcX",
	"./inapp-message.svg": "H4IT",
	"./inbox.svg": "kczp",
	"./integrations-nav.svg": "yJmH",
	"./integrations.svg": "43S0",
	"./intelligence-computations.svg": "lyQG",
	"./intelligence-dashboards.svg": "Q6IH",
	"./intelligence-data-engine.svg": "u0nw",
	"./intelligence-infinityai.svg": "jtvX",
	"./laptop-message.svg": "NVuh",
	"./laptop.svg": "CcVr",
	"./lightbulb.svg": "QREM",
	"./lightning.svg": "UADr",
	"./location-multiple.svg": "iA4Z",
	"./location.svg": "pF+L",
	"./lock.svg": "CNP7",
	"./logout.svg": "qX2G",
	"./maxautomation.svg": "Fu+8",
	"./message-settings.svg": "R2h9",
	"./messages.svg": "2svZ",
	"./middle-east.svg": "KXrz",
	"./mobile-message.svg": "CNCk",
	"./mobile.svg": "aynh",
	"./navdropdown-arrow.svg": "Nfd9",
	"./navigation-analytics.svg": "7Man",
	"./navigation-campaigns.svg": "eJVW",
	"./navigation-collapse-chevron.svg": "33Vj",
	"./navigation-content.svg": "yOes",
	"./navigation-dashboard.svg": "eSJ2",
	"./navigation-data.svg": "9To3",
	"./navigation-gamification-dice.svg": "gREG",
	"./navigation-open-chevron.svg": "6S+S",
	"./navigation-report.svg": "bBur",
	"./navigation-settings.svg": "yTLW",
	"./north-america.svg": "9+Ap",
	"./notice.svg": "ACJ6",
	"./oceania.svg": "doWa",
	"./optimove.svg": "Nmnk",
	"./pages.svg": "blPW",
	"./paper-plane-2.svg": "FWO4",
	"./paper-plane.svg": "mYHx",
	"./path.svg": "J1uX",
	"./path3.svg": "UdrE",
	"./pencil.svg": "QBLF",
	"./person-delete.svg": "pwB9",
	"./person-frame.svg": "5KkW",
	"./person-heart.svg": "EN0x",
	"./person-note.svg": "VpLl",
	"./person-sync.svg": "Hdi5",
	"./person.svg": "8dUg",
	"./plus.svg": "z78o",
	"./provider-info.svg": "ejzq",
	"./salesforce-cloud.svg": "Reyl",
	"./salesforce.svg": "1hqt",
	"./server.svg": "qzUN",
	"./settings-horiz.svg": "8vIP",
	"./settings-vertical.svg": "dv0d",
	"./settings.svg": "Cic/",
	"./share.svg": "KUGl",
	"./shoping-cart-remove.svg": "qHec",
	"./smartphone.svg": "ZJwG",
	"./sms-logo.svg": "0G3p",
	"./snippet-html.svg": "yf7g",
	"./snippet-text.svg": "Zq7M",
	"./snippet.svg": "RXWN",
	"./south-america.svg": "S5ko",
	"./star.svg": "SziX",
	"./stop.svg": "KvHR",
	"./stopwatch.svg": "rGVb",
	"./success.svg": "UgYE",
	"./sync.svg": "Dnmn",
	"./task-manager.svg": "n9cs",
	"./text.svg": "Vhpx",
	"./three-people.svg": "oSl7",
	"./tick.svg": "g0Iy",
	"./toolbar-finances.svg": "1AUo",
	"./toolbar-logs.svg": "HpOs",
	"./translate.svg": "bCxx",
	"./translations.svg": "LLA2",
	"./trigger.svg": "cOeF",
	"./user-check.svg": "vH73",
	"./user-data.svg": "XzLX",
	"./user-management.svg": "eBgY",
	"./user-profile.svg": "dObN",
	"./user-risk.svg": "zlWG",
	"./variant-testing.svg": "iaDg",
	"./vcard.svg": "L0YD",
	"./vertical-barchart.svg": "s0IM",
	"./warning.svg": "55g1",
	"./web.svg": "xTXA",
	"./xp-logo-blue.svg": "Sw8S"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aKtQ";


//////////////////
// WEBPACK FOOTER
// ./src/img/svg ^\.\/.*\.svg$
// module id = aKtQ
// module chunks = 38 43